export interface WidgetConfig {
  /**
   * Full Pardot/MCAE form URL as found in MCAE under "Embed Code".
   * Preferred input — when set the widget uses this URL verbatim and the
   * legacy `pardotAccountId` / `pardotFormId` / `pardotFormHost` triplet is
   * ignored. Required for newer MCAE Lightning Forms whose URL contains a
   * publication-date segment that the legacy triplet can't express, e.g.
   *   https://ae.novyx.nl/l/1075992/2026-04-22/d1v76c
   */
  pardotFormUrl: string
  /** @deprecated Prefer `pardotFormUrl`. Kept for backwards-compat. */
  pardotAccountId: string
  /** @deprecated Prefer `pardotFormUrl`. Kept for backwards-compat. */
  pardotFormId: string
  /** @deprecated Prefer `pardotFormUrl`. Kept for backwards-compat. */
  pardotFormHost: string
  reportPageUrl: string
}

const PLACEHOLDER_ACCOUNT_ID = 'PARDOT_ACCOUNT_ID_PENDING'
const PLACEHOLDER_FORM_ID = 'PARDOT_FORM_ID_PENDING'
const DEFAULT_PARDOT_HOST = 'go.pardot.com'
const DEFAULT_REPORT_URL = 'https://rapport.novyx.nl'

export function loadConfig(overrides: Partial<WidgetConfig> = {}): WidgetConfig {
  const env = (import.meta.env ?? {}) as Record<string, string | undefined>

  return {
    pardotFormUrl:
      overrides.pardotFormUrl ?? env.VITE_PARDOT_FORM_URL ?? '',
    pardotAccountId:
      overrides.pardotAccountId ??
      env.VITE_PARDOT_ACCOUNT_ID ??
      PLACEHOLDER_ACCOUNT_ID,
    pardotFormId:
      overrides.pardotFormId ?? env.VITE_PARDOT_FORM_ID ?? PLACEHOLDER_FORM_ID,
    pardotFormHost:
      overrides.pardotFormHost ?? env.VITE_PARDOT_FORM_HOST ?? DEFAULT_PARDOT_HOST,
    reportPageUrl:
      overrides.reportPageUrl ?? env.VITE_REPORT_PAGE_URL ?? DEFAULT_REPORT_URL,
  }
}

export function isPlaceholderConfig(config: WidgetConfig): boolean {
  if (config.pardotFormUrl.length > 0) {
    return false
  }
  return (
    config.pardotAccountId === PLACEHOLDER_ACCOUNT_ID ||
    config.pardotFormId === PLACEHOLDER_FORM_ID
  )
}
